import { useEffect } from "react";

/* Stop the PAGE scrolling while a full-screen task is on screen. */
export const usePageScrollLock = (locked = true) => {
  useEffect(() => {
    if (!locked) return undefined;
    if (typeof document === "undefined") return undefined;

    const { body, documentElement: html } = document;
    const previousBody = body.style.overflow;
    const previousHtml = html.style.overflow;

    /* Both: `body` alone is enough in most browsers, but a root element that
       has picked up its own scroller keeps one otherwise. */
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";

    return () => {
      body.style.overflow = previousBody;
      html.style.overflow = previousHtml;
    };
  }, [locked]);
};

export default usePageScrollLock;
